import { render, staticRenderFns } from "./bills-info.vue?vue&type=template&id=89ba2786&scoped=true"
import script from "./bills-info.vue?vue&type=script&lang=js"
export * from "./bills-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ba2786",
  null
  
)

export default component.exports